import { ShipmentUpdateResponseModel } from "../apiModels/shipmentUpdateResponseModel";
import { toNullableLocaleDateTimeString, formatNullableString } from "../utilities";

export default function TrackShipmentResultTableRowFormatter(props: { shipmentUpdate: ShipmentUpdateResponseModel }) {
    return (
        <tr key={props.shipmentUpdate.shipmentStatusId}>
            <td>{formatNullableString(props.shipmentUpdate.description)}</td>
            <td>{formatNullableString(props.shipmentUpdate.location)}</td>
            <td>{formatNullableString(props.shipmentUpdate.shipmentStatus)}</td>
            <td>{toNullableLocaleDateTimeString(props.shipmentUpdate.updateTime)}</td>
        </tr>
    );
};